import React, { useEffect, Component } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { HowItWorks } from './pages/HowItWorks';
import { Features } from './pages/Features';
import { Integrations } from './pages/Integrations';
import { Pricing } from './pages/Pricing';
import { CaseStudy } from './pages/CaseStudy';
import { Security } from './pages/Security';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import ScrollToTop from './components/ScrollToTop'; // We'll create this inline or just let it be
// Simple ScrollToTop component
function ScrollToTopComponent() {
  const {
    useLocation
  } = require('react-router-dom');
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function App() {
  return <Router data-id="element-0">
      <ScrollToTopComponent data-id="element-1" />
      <div className="min-h-screen flex flex-col font-sans text-gray-900" data-id="element-2">
        <Header data-id="element-3" />
        <main className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
            <Route path="/how-it-works" element={<HowItWorks data-id="element-9" />} data-id="element-8" />
            <Route path="/features" element={<Features data-id="element-11" />} data-id="element-10" />
            <Route path="/integrations" element={<Integrations data-id="element-13" />} data-id="element-12" />
            <Route path="/pricing" element={<Pricing data-id="element-15" />} data-id="element-14" />
            <Route path="/case-study" element={<CaseStudy data-id="element-17" />} data-id="element-16" />
            <Route path="/security" element={<Security data-id="element-19" />} data-id="element-18" />
            <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-21" />} data-id="element-20" />
          </Routes>
        </main>
        <Footer data-id="element-22" />
      </div>
    </Router>;
}